import React from "react";
import gold from "../assets/gold-sequin.webp";
import silver from "../assets/silver-sequin.webp";
import champagne from "../assets/champagne-sequin.webp";
import rosegold from "../assets/rose-gold-sequin.webp";
import black from "../assets/black-sequin.webp";
import whiteflower from "../assets/White-flower-sequin.webp";
import grasshedge from "../assets/grass-hedge-sequin.webp";

const FEATURED = [
  { name: "Gold Sequin", img: gold },
  { name: "Silver Sequin", img: silver },
  { name: "Champagne Sequin", img: champagne  },
];

const OPTIONS = [
  { name: "Rose Gold Sequin", img: rosegold },
  { name: "Black Sequin", img: black },
  { name: "White Flower", img: whiteflower },
  { name: "Grass Hedge", img: grasshedge},
];

function BackdropCard({ item, size = "md" }) {
  const height = size === "lg" ? "h-44 md:h-52" : "h-28 md:h-32";

  return (
    <div
      className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04]
                 shadow-[0_14px_30px_rgba(0,0,0,0.45)]
                 hover:shadow-[0_18px_45px_rgba(227,67,100,0.20)]
                 hover:-translate-y-1 transition-all duration-300"
    >
      <div className={`relative ${height}`}>
        <img
          src={item.img}
          alt={item.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(227,67,100,0.18),transparent_55%)]" />
      </div>

      <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
        <span className="text-[11px] md:text-xs font-semibold tracking-[0.28em] uppercase text-white">
          {item.name}
        </span>
        <span className="text-[10px] text-white/70 bg-black/35 border border-white/10 px-2 py-1 rounded-full backdrop-blur-md">
          View
        </span>
      </div>
    </div>
  );
}

export default function BackdropGrid() {
  return (
    <section id="backdrop-gallery" className="py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 animate-fade-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
            Backdrops
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            Choose Your Backdrop
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto text-sm md:text-base">
            From shimmering sequins to elegant florals and lush hedge walls —
            pick the perfect backdrop to match your vibe.
          </p>
        </div>

        {/* Featured row */}
        <div className="grid md:grid-cols-3 gap-5 mb-10 animate-fade-up">
          {FEATURED.map((b) => (
            <BackdropCard key={b.name} item={b} size="lg" />
          ))}
        </div>

        {/* Options */}
        <div className="grid md:grid-cols-3 gap-5 animate-fade-up">
          {OPTIONS.slice(0, 3).map((b) => (
            <BackdropCard key={b.name} item={b} />
          ))}
        </div>

        {/* Single wide row for Grass Hedge */}
        <div className="mt-5 grid md:grid-cols-3 gap-5 animate-fade-up">
          <div className="md:col-span-2">
            <BackdropCard item={OPTIONS[3]} size="lg" />
          </div>

          {/* small CTA card */}
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6
                          shadow-[0_14px_30px_rgba(0,0,0,0.45)] flex flex-col justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
                Need Custom?
              </p>
              <h3 className="text-lg font-semibold mb-2">Brand & Theme Matching</h3>
              <p className="text-sm text-gray-300">
                Want a specific color, logo, or theme? We can arrange custom setups for corporate
                activations and weddings.
              </p>
            </div>

            <button
              onClick={() =>
                document.getElementById("contact")?.scrollIntoView({
                  behavior: "smooth",
                })
              }
              className="mt-5 inline-flex justify-center items-center rounded-full bg-[#E34364]
                         px-5 py-2.5 text-sm font-semibold shadow-[0_18px_45px_rgba(227,67,100,0.45)]
                         hover:bg-[#f15477] transition"
            >
              Request a Quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
